export const fmt = (n) => (Number(n) || 0).toLocaleString("cs-CZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Kč";
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("cs-CZ") : "—");
export const inputCls = "w-full px-3 py-2 border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm";
export const DEFAULT_PCTS = [20, 20, 20, 40];
export const STATUS = {
    ceka: { l: "Čeká", cls: "bg-slate-100 text-slate-700 border-slate-300" },
    schvaleno: { l: "Schváleno k výplatě", cls: "bg-amber-50 text-amber-800 border-amber-400" },
    vyplaceno: { l: "Vyplaceno", cls: "bg-emerald-50 text-emerald-800 border-emerald-400" },
};
export const REASONS = { vypoved: "Výpověď", dohoda: "Dohoda", jine: "Jiné" };
